import {useHeaderAsState} from "./use-header-as-state";
export function useMagnoliaLanguages(): string[] {
  const runtimeConfig = useRuntimeConfig();
  const value = useHeaderAsState('x-mgnl-languages');
  const languages = value ?? runtimeConfig.public.mgnl.languages;
  return languages.split(" ") ?? [];
}
